import _ from 'underscore';

const campaignTypeEnum = {
  1: 'Search',
  Default: 'Search',
  PerformanceMax: 'Pmax',
};

export function getCampaignType(campaign) {
  const rawType = _.result(campaign, 'CampaignType');
  return _.result(campaignTypeEnum, rawType, rawType);
}
